/**
 * 转账选择验证方式页面
 */

import React, { useCallback, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Toast } from 'react-vant'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import SelectVerification, { VerActionType } from '@/components/SelectVerification'

/**
 * 路由状态参数
 */
interface SelectVerificationState {
  /** 转账参数 */
  transferData: {
    amount: string
    pay_type: string
    target_user_info: string
    target_user_type: string
    remark?: string
  }
  /** 用于跳转成功页面的数据 */
  successData: {
    currency: string
    currencyIcon: string
    amount: string
    recipientType: string
    recipientValue: string
    fee: string
  }
}

export default React.memo(function TransferSelectVerification() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  // 从路由状态中获取参数
  const state = location.state as SelectVerificationState | null

  // 如果没有传递必要参数，返回上一页
  useEffect(() => {
    if (!state || !state.transferData) {
      console.error('缺少转账参数')
      Toast.fail(t('参数错误'))
      navigate(-1)
      return
    }
  }, [])

  // 处理验证方式选择成功后的回调
  const handleVerificationSuccess = useCallback(({ actionType, account }: { actionType: VerActionType; account: string }) => {
    navigate('/transfer/verify-code', {
      state: {
        transferData: state?.transferData,
        successData: state?.successData,
        verification: actionType,
        account, // 邮箱账户（谷歌验证时为空）
      }
    })
  }, [navigate, state])

  if (!state) {
    return null
  }

  return (
    <PageLayout>
      <Header
        leftChildren={<Back />}
      />
      <div className="px-6 py-6">
        <SelectVerification
          scene="balance_transfer"
          onSuccess={handleVerificationSuccess}
        />
      </div>
    </PageLayout>
  )
})
